/* ============================================================
   INCIDENTAL — comportamientos propios sobre el tema Fabric.
   Todo es aditivo: no reemplaza ni depende de guiones del tema.
   ============================================================ */

(function () {
  'use strict';

  var enEditor = window.Shopify && window.Shopify.designMode;

  function listo(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  /* ---------- 1. pantalla de carga con el logo ---------- */

  /* Como llegamos a esta pagina: 'navigate' (clic normal o primera visita),
     'reload' (recargar) o 'back_forward' (flechas del navegador). */
  function tipoDeNavegacion() {
    try {
      var e = performance.getEntriesByType('navigation')[0];
      if (e && e.type) return e.type;
    } catch (_) {}
    return 'navigate';
  }

  function initPreloader() {
    var el = document.getElementById('inc-preloader');
    if (!el) return;

    // en el editor de temas estorba: fuera al instante
    if (enEditor) {
      el.remove();
      return;
    }

    var tipo = tipoDeNavegacion();
    var primeraVez = false;
    try {
      primeraVez = !sessionStorage.getItem('inc-visto');
      sessionStorage.setItem('inc-visto', '1');
    } catch (_) {
      primeraVez = true; // navegacion privada o cookies bloqueadas
    }

    /* Cuanto se queda la pantalla de carga:
       - al volver atras/adelante: nada, molesta y tapa el sitio al que vuelves
       - primera visita o recarga: la animacion completa
       - al pasar de una pagina a otra (entrar a una prenda): un guino corto */
    /* En la ficha de producto la pantalla de carga estorba: el cliente viene
       de pinchar una prenda y ese parpadeo se lee como un fallo. */
    var esFicha = location.pathname.indexOf('/products/') !== -1;

    var minimo;
    if (tipo === 'back_forward' || esFicha) {
      el.remove();
      return;
    } else if (primeraVez || tipo === 'reload') {
      minimo = 500;
    } else {
      minimo = 120;
    }

    var inicio = Date.now();

    function ocultar() {
      var espera = Math.max(0, minimo - (Date.now() - inicio));
      setTimeout(function () {
        el.classList.add('inc-preloader--fuera');
        setTimeout(function () {
          if (el.parentNode) el.remove();
        }, 400);
      }, espera);
    }

    /* Antes esperabamos a window.load, que incluye TODAS las imagenes, las
       resenas y los pixeles de analitica (~264 peticiones en la home): eso
       dejaba la pantalla de carga puesta ~1,2s de mas, con la pagina ya lista.
       Ahora esperamos solo a lo que el cliente ve: el DOM y la primera imagen
       de la portada. El CSS ya esta aplicado antes del DOM, asi que no hay
       riesgo de ensenar la pagina sin estilos. */
    function listoParaMostrar() {
      var img = document.querySelector('.inc-hero__img, .inc-hero img, main img');
      if (!img || img.complete) return ocultar();

      var hecho = false;
      function seguir() {
        if (hecho) return;
        hecho = true;
        ocultar();
      }
      img.addEventListener('load', seguir);
      img.addEventListener('error', seguir);
      // si esa imagen tarda demasiado, no castigamos al cliente por ella
      setTimeout(seguir, 1200);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', listoParaMostrar);
    } else {
      listoParaMostrar();
    }

    // red de seguridad: nunca dejar la pantalla pegada
    setTimeout(function () {
      if (el.parentNode) el.remove();
    }, 6000);
  }

  /* ---------- 2. fecha y hora local en el pie ---------- */
  function initFechaLocal() {
    var marcadores = [];
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null);
    var nodo;
    while ((nodo = walker.nextNode())) {
      if (nodo.nodeValue && nodo.nodeValue.indexOf('[fecha]') !== -1) marcadores.push(nodo);
    }
    if (!marcadores.length) return;

    function texto() {
      var ahora = new Date();
      var f = new Intl.DateTimeFormat('es-CO', {
        weekday: 'long',
        day: 'numeric',
        month: 'long',
        hour: 'numeric',
        minute: '2-digit',
        hour12: true,
        timeZone: 'America/Bogota'
      }).format(ahora);
      return f.replace(',', ',').replace(' a. m.', ' a.m.').replace(' p. m.', ' p.m.');
    }

    marcadores.forEach(function (n) {
      var plantilla = n.nodeValue;
      var span = document.createElement('span');
      span.className = 'inc-fecha-local';
      span.textContent = plantilla.replace('[fecha]', texto());
      n.parentNode.replaceChild(span, n);
      setInterval(function () {
        span.textContent = plantilla.replace('[fecha]', texto());
      }, 30000);
    });
  }

  /* ---------- 3. boton de volver arriba ---------- */
  function initVolverArriba() {
    if (document.querySelector('.inc-arriba')) return;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'inc-arriba';
    btn.setAttribute('aria-label', 'Volver arriba');
    btn.innerHTML =
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true">' +
      '<path d="M12 19V6M6 12l6-6 6 6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    document.body.appendChild(btn);

    btn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });

    function alternar() {
      btn.classList.toggle('inc-arriba--visible', window.scrollY > 600);
    }
    alternar();
    window.addEventListener('scroll', alternar, { passive: true });
  }

  /* ---------- 4. ventana de tabla de medidas ----------
     Delegado a nivel de documento a proposito: el boton "Guia de tallas"
     puede aparecer mas tarde dentro del modal de compra rapida (home,
     colecciones), momento en el que la ventana #inc-medidas todavia no
     existe en esa pagina porque solo se dibuja en la plantilla de producto.
     Si no la encuentra, la trae con un fetch a la ficha del producto
     (data-inc-medidas-url) y la agrega a la pagina antes de abrirla. */
  function initModales() {
    document.querySelectorAll('[data-inc-modal-abrir]').forEach(function (t) {
      var id = t.getAttribute('data-inc-modal-abrir');
      if (!document.getElementById(id) && !t.getAttribute('data-inc-medidas-url')) {
        t.style.display = 'none';
      }
    });

    function cerrar(modal) {
      modal.classList.remove('is-open');
      document.body.classList.remove('inc-modal-abierto');
    }

    function abrir(modal, trigger) {
      // Si el boton que la abre vive dentro de un <dialog> nativo (por ejemplo
      // el modal de compra rapida), hay que meter la ventana ahi tambien:
      // un <dialog> abierto pinta siempre por encima del resto de la pagina
      // sin importar el z-index, asi que afuera de el quedaria tapada.
      var contenedor = (trigger && trigger.closest('dialog[open]')) || document.body;
      if (modal.parentElement !== contenedor) {
        contenedor.appendChild(modal);
      }

      modal.classList.add('is-open');
      document.body.classList.add('inc-modal-abierto');
      var x = modal.querySelector('.inc-modal__cerrar');
      if (x) x.focus();
    }

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-inc-modal-abrir]');
      if (trigger) {
        var id = trigger.getAttribute('data-inc-modal-abrir');
        var destino = document.getElementById(id);

        if (destino) {
          e.preventDefault();
          abrir(destino, trigger);
          return;
        }

        var url = trigger.getAttribute('data-inc-medidas-url');
        if (!url) return;
        e.preventDefault();

        fetch(url)
          .then(function (r) {
            return r.text();
          })
          .then(function (texto) {
            var doc = new DOMParser().parseFromString(texto, 'text/html');
            var nuevo = doc.getElementById(id);
            if (!nuevo) return;
            var viejo = document.getElementById(id);
            if (viejo) viejo.remove();
            abrir(nuevo, trigger);
          })
          .catch(function () {});
        return;
      }

      var modal = e.target.closest('.inc-modal');
      if (!modal) return;

      if (
        e.target.closest('.inc-modal__cerrar') ||
        e.target.classList.contains('inc-modal__backdrop')
      ) {
        cerrar(modal);
        return;
      }

      var tab = e.target.closest('.inc-tab');
      if (!tab) return;
      var destinoTab = tab.getAttribute('data-inc-tab');
      modal.querySelectorAll('.inc-tab').forEach(function (t) {
        t.classList.toggle('is-active', t === tab);
        t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
      });
      modal.querySelectorAll('.inc-modal__panel-tab').forEach(function (p) {
        p.classList.toggle('is-active', p.getAttribute('data-inc-tab-panel') === destinoTab);
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      document.querySelectorAll('.inc-modal.is-open').forEach(cerrar);
    });
  }

  /* ---------- 4b. contador regresivo ---------- */
  function initContador() {
    document.querySelectorAll('[data-inc-contador]').forEach(function (el) {
      if (el.dataset.incListo === '1') return;
      el.dataset.incListo = '1';

      var fecha = new Date(el.getAttribute('data-inc-contador-fecha'));
      if (isNaN(fecha.getTime())) return;

      var dias = el.querySelector('[data-inc-dias]');
      var horas = el.querySelector('[data-inc-horas]');
      var minutos = el.querySelector('[data-inc-minutos]');
      var segundos = el.querySelector('[data-inc-segundos]');

      function pad(n) {
        return n < 10 ? '0' + n : String(n);
      }

      var intervalo = null;

      function actualizar() {
        var restante = fecha.getTime() - Date.now();

        if (restante <= 0) {
          if (dias) dias.textContent = '00';
          if (horas) horas.textContent = '00';
          if (minutos) minutos.textContent = '00';
          if (segundos) segundos.textContent = '00';
          el.classList.add('inc-contador--terminado');
          if (intervalo) clearInterval(intervalo);
          return;
        }

        var s = Math.floor(restante / 1000);
        if (dias) dias.textContent = pad(Math.floor(s / 86400));
        if (horas) horas.textContent = pad(Math.floor((s % 86400) / 3600));
        if (minutos) minutos.textContent = pad(Math.floor((s % 3600) / 60));
        if (segundos) segundos.textContent = pad(s % 60);
      }

      actualizar();
      intervalo = setInterval(actualizar, 1000);
    });
  }

  /* ---------- 5. hero deslizable ---------- */
  function initHero(raiz) {
    var ambito = raiz || document;
    ambito.querySelectorAll('[data-inc-hero]').forEach(function (hero) {
      if (hero.dataset.incListo === '1') return;
      hero.dataset.incListo = '1';

      var track = hero.querySelector('[data-inc-hero-track]');
      var slides = Array.prototype.slice.call(hero.querySelectorAll('[data-inc-hero-slide]'));
      if (!track || slides.length < 2) return;

      var puntos = Array.prototype.slice.call(hero.querySelectorAll('[data-inc-hero-ir]'));
      var actual = 0;
      var timer = null;
      var espera = parseInt(hero.dataset.autoplay, 10) || 0;
      var sinMovimiento = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function pintar() {
        track.style.transform = 'translateX(' + -100 * actual + '%)';
        slides.forEach(function (s, i) {
          s.setAttribute('aria-hidden', i === actual ? 'false' : 'true');
        });
        puntos.forEach(function (p, i) {
          p.classList.toggle('is-active', i === actual);
        });
      }

      function ir(i) {
        actual = (i + slides.length) % slides.length;
        pintar();
      }

      function siguiente() { ir(actual + 1); }
      function anterior() { ir(actual - 1); }

      function arrancar() {
        if (!espera || sinMovimiento) return;
        parar();
        timer = setInterval(siguiente, espera);
      }
      function parar() {
        if (timer) clearInterval(timer);
        timer = null;
      }
      function reiniciar() {
        parar();
        arrancar();
      }

      var prev = hero.querySelector('[data-inc-hero-prev]');
      var next = hero.querySelector('[data-inc-hero-next]');
      if (prev) prev.addEventListener('click', function () { anterior(); reiniciar(); });
      if (next) next.addEventListener('click', function () { siguiente(); reiniciar(); });

      puntos.forEach(function (p) {
        p.addEventListener('click', function () {
          ir(parseInt(p.getAttribute('data-inc-hero-ir'), 10) || 0);
          reiniciar();
        });
      });

      // deslizar con el dedo
      var x0 = null;
      hero.addEventListener('touchstart', function (e) {
        x0 = e.changedTouches[0].clientX;
        parar();
      }, { passive: true });
      hero.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 45) {
          if (dx < 0) siguiente();
          else anterior();
        }
        x0 = null;
        arrancar();
      }, { passive: true });

      hero.addEventListener('mouseenter', parar);
      hero.addEventListener('mouseleave', arrancar);

      // no gastar ciclos con la pestana en segundo plano
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) parar();
        else arrancar();
      });

      pintar();
      arrancar();
    });
  }

  /* ---------- 6. precio dentro del boton de agregar al carrito ----------
     El texto del boton sale de una cadena de idioma del tema, asi que no
     admite el precio. Lo anadimos aqui y lo refrescamos cuando el tema
     repinta la ficha al cambiar de talla o color. */
  function initPrecioEnBoton(raiz) {
    var ambito = raiz && raiz.querySelectorAll ? raiz : document;
    var fichas = ambito.querySelectorAll('.product-information, .featured-product');
    if (!fichas.length) return;

    fichas.forEach(function (ficha) {
      var boton = ficha.querySelector('add-to-cart-component button');
      if (!boton || boton.disabled) return;

      var precioEl = ficha.querySelector('.price');
      if (!precioEl) return;

      // solo la primera linea del bloque de precio: el importe, sin "impuestos incluidos"
      var precio = (precioEl.textContent || '').trim().split('\n')[0].trim();
      if (!precio) return;

      var span = boton.querySelector('.inc-atc-precio');
      if (!span) {
        span = document.createElement('span');
        span.className = 'inc-atc-precio';
        boton.appendChild(span);
      }
      if (span.textContent !== precio) span.textContent = precio;
    });
  }

  function vigilarPrecio() {
    var zona = document.querySelector('.product-information');
    if (!zona || !window.MutationObserver) return;
    // sin esto se acumularia un observador nuevo en cada repintado del editor
    if (zona.dataset.incPrecioVigilado === '1') return;
    zona.dataset.incPrecioVigilado = '1';

    var pendiente = null;
    var obs = new MutationObserver(function () {
      if (pendiente) clearTimeout(pendiente);
      // el tema repinta en varios pasos: esperamos a que termine
      pendiente = setTimeout(function () {
        initPrecioEnBoton(document);
        // al cambiar de talla el tema repinta el selector y se pierde el reorden
        initFilaTalla();
      }, 120);
    });
    obs.observe(zona, { childList: true, subtree: true, characterData: true });
  }

  /* ---------- 7. fila de talla al estilo de la referencia ----------
     Objetivo: a la izquierda el nombre de la opcion con "Guia de Tallas" al
     lado y debajo la talla elegida; a la derecha los botones.
     Fabric solo pinta <legend>Talla</legend> y los botones sueltos, asi que
     aqui se reordena SIN tocar los botones (el guion del tema los necesita
     como hijos directos del fieldset). */
  /* al cambiar de talla el tema repinta el selector y destruye el enlace de la
     guia, porque para entonces ya lo habiamos movido dentro de el. Guardamos
     una copia (atada a la ficha actual) para poder reponerlo. */
  var guiaPlantilla = null;
  var guiaPlantillaRuta = '';

  function initFilaTalla() {
    var opciones = document.querySelectorAll('.variant-picker .variant-option');
    if (!opciones.length) return;

    var ruta = location.pathname;
    if (guiaPlantillaRuta !== ruta) {
      guiaPlantilla = null;
      guiaPlantillaRuta = ruta;
    }

    var existentes = document.querySelectorAll('.inc-guia');
    var guia = null;
    if (existentes.length) {
      guia = existentes[0];
      // si un repintado dejo copias sueltas, nos quedamos solo con una
      for (var i = 1; i < existentes.length; i++) {
        if (existentes[i].parentNode) existentes[i].parentNode.removeChild(existentes[i]);
      }
      guiaPlantilla = guia.cloneNode(true);
    } else if (guiaPlantilla) {
      guia = guiaPlantilla.cloneNode(true);
    }

    opciones.forEach(function (fs) {
      var legend = fs.querySelector('legend');
      if (!legend) return;

      var cabecera = legend.querySelector('.inc-opcion__cabecera');
      if (!cabecera) {
        var nombre = document.createElement('span');
        nombre.className = 'inc-opcion__nombre';
        nombre.textContent = (legend.textContent || '').trim();
        cabecera = document.createElement('span');
        cabecera.className = 'inc-opcion__cabecera';
        cabecera.appendChild(nombre);
        legend.textContent = '';
        legend.appendChild(cabecera);
      }

      // el enlace de la guia se coloca junto al nombre de la opcion de talla
      if (guia && !cabecera.contains(guia) && /talla|size/i.test(cabecera.textContent)) {
        cabecera.appendChild(guia);
      }

      var valor = legend.querySelector('.inc-opcion__valor');
      if (!valor) {
        valor = document.createElement('small');
        valor.className = 'inc-opcion__valor';
        legend.appendChild(valor);
      }

      function pintarValor() {
        var sel = fs.querySelector('input:checked');
        valor.textContent = sel ? sel.value : '';
      }

      if (fs.dataset.incFila !== '1') {
        fs.dataset.incFila = '1';
        fs.addEventListener('change', pintarValor);
      }
      pintarValor();
    });
  }

  /* ---------- 8. red de seguridad al volver atras ----------
     El tema guarda la posicion del scroll en history.state y la repone en un
     requestAnimationFrame tras 'pageshow'. Si en ese instante la pagina aun
     no ha alcanzado su altura final, el propio tema recorta la posicion
     (Math.min con scrollHeight) y acabas arriba del todo.
     Aqui guardamos aparte la posicion y, SOLO al volver atras/adelante, la
     reponemos otra vez cuando la pagina ya se ha asentado. */
  function initVolverDondeEstaba() {
    var ANCHO_ESCRITORIO = window.matchMedia('(min-width: 990px)');

    function contenedor() {
      if (ANCHO_ESCRITORIO.matches) {
        return document.querySelector('.page-wrapper') || document.scrollingElement || document.documentElement;
      }
      return document.scrollingElement || document.documentElement;
    }

    function clave() {
      return 'inc-scroll:' + location.pathname + location.search;
    }

    function guardar() {
      try {
        sessionStorage.setItem(clave(), String(contenedor().scrollTop));
      } catch (_) {}
    }

    window.addEventListener('pagehide', guardar);
    // pagehide no siempre dispara en moviles al cambiar de app o pestana
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) guardar();
    });

    if (tipoDeNavegacion() !== 'back_forward') return;

    var destino = null;
    try {
      destino = parseFloat(sessionStorage.getItem(clave()));
    } catch (_) {}
    if (!destino || !isFinite(destino) || destino <= 0) return;

    var intentos = 0;
    function reponer() {
      var el = contenedor();
      var tope = Math.max(0, el.scrollHeight - el.clientHeight);
      if (tope >= destino) {
        el.scrollTo({ top: destino, behavior: 'instant' });
        return;
      }
      // la pagina todavia no es tan alta: esperar a que carguen imagenes
      if (++intentos < 20) setTimeout(reponer, 100);
      else el.scrollTo({ top: tope, behavior: 'instant' });
    }
    reponer();
  }

  /* ---------- 7. clics a WhatsApp (barra de anuncios + boton flotante) ---------- */
  /* Un solo listener delegado: cubre el boton flotante, el enlace de la barra
     de anuncios y cualquier otro enlace a wa.me que se agregue despues, sin
     tener que engancharlo de nuevo en cada seccion. */
  function initWhatsappTracking() {
    document.addEventListener(
      'click',
      function (e) {
        var link = e.target.closest('a[href*="wa.me"]');
        if (!link) return;

        var ubicacion = 'otro';
        if (link.closest('.inc-whatsapp')) {
          ubicacion = 'boton_flotante';
        } else if (link.classList.contains('announcement-bar__link')) {
          ubicacion = 'barra_anuncios';
        }

        // El boton flotante abre pestana nueva: la pagina actual no se
        // descarga, no hace falta retrasar la navegacion.
        var mismaPestana = link.target !== '_blank';
        if (mismaPestana) {
          // Se previene ANTES de llamar a publish(): si algo de ahi fallara,
          // igual queremos quedarnos en la pagina para reintentar nosotros
          // la navegacion (ver setTimeout mas abajo), no dejar que se
          // pierda el evento por una carrera con la descarga de la pagina.
          e.preventDefault();
        }

        try {
          if (window.Shopify && typeof window.Shopify.analytics?.publish === 'function') {
            // OJO: publish() no siempre devuelve una promesa (comprobado en
            // este sitio) — por eso todo esto va en try/catch y no se
            // encadena un .catch() a ciegas.
            var resultado = window.Shopify.analytics.publish('incidental:whatsapp_click', {
              ubicacion: ubicacion,
              href: link.href,
              pagina: location.pathname,
            });
            if (resultado && typeof resultado.catch === 'function') {
              resultado.catch(function () {});
            }
          }
        } catch (err) {}

        if (!mismaPestana) return;

        var yaFue = false;
        function ir() {
          if (yaFue) return;
          yaFue = true;
          window.location.href = link.href;
        }
        setTimeout(ir, 150);
      },
      true
    );
  }

  initPreloader();
  initWhatsappTracking();

  listo(function () {
    initFechaLocal();
    initVolverArriba();
    initModales();
    initContador();
    initHero();
    initPrecioEnBoton(document);
    initFilaTalla();
    vigilarPrecio();
  });

  // la reposicion del scroll espera a que la pagina tenga su altura final
  window.addEventListener('load', initVolverDondeEstaba);

  // el editor de temas repinta secciones: volver a enganchar lo necesario
  document.addEventListener('shopify:section:load', function (e) {
    initModales();
    initFechaLocal();
    initContador();
    initHero(e.target || document);
    initPrecioEnBoton(document);
    initFilaTalla();
    vigilarPrecio();
  });
})();
